(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gold-price"] && !Shopify.designMode) return;
  try {
    
  class GoldPriceSection {
    constructor(section) {
      this.section = section;
      this.valueElement = section.querySelector('[data-gold-price-value]');
      this.updatedElement = section.querySelector('[data-gold-price-updated]');
      this.apiBaseUrl = section.dataset.apiBaseUrl || 'https://api.gold-api.com/price/XAU';
      this.currencyCode = section.dataset.currencyCode || 'EUR';
      this.karat = Number(section.dataset.karat || 24);
      this.cacheHours = Number(section.dataset.cacheHours || 12);
      this.loadingText = section.dataset.loadingText || 'Loading gold price';
      this.errorText = section.dataset.errorText || 'Gold price unavailable';
      this.perGramText = section.dataset.perGramText || 'per gram';
      this.updatedPrefix = section.dataset.updatedPrefix || 'Updated';
      this.cacheKey = `gold-price:${this.apiBaseUrl}:${this.currencyCode}:${this.karat}`;
    }

    init() {
      const cached = this.getCachedPrice();

      if (cached) {
        this.render(cached);
        return;
      }

      this.fetchPrice();
    }

    getCachedPrice() {
      try {
        const item = window.localStorage.getItem(this.cacheKey);

        if (!item) {
          return null;
        }

        const cached = JSON.parse(item);
        const expiresAt = Number(cached.expiresAt || 0);

        if (Date.now() > expiresAt) {
          window.localStorage.removeItem(this.cacheKey);
          return null;
        }

        return cached.data;
      } catch (error) {
        return null;
      }
    }

    setCachedPrice(data) {
      try {
        const expiresAt = Date.now() + this.cacheHours * 60 * 60 * 1000;
        window.localStorage.setItem(this.cacheKey, JSON.stringify({ data, expiresAt }));
      } catch (error) {
      }
    }

    async fetchPrice() {
      try {
        const response = await fetch(this.endpointUrl(), {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error('Price request failed');
        }

        const data = await response.json();
        const normalized = this.normalize(data);

        this.setCachedPrice(normalized);
        this.render(normalized);
      } catch (error) {
        this.renderError();
      }
    }

    endpointUrl() {
      const base = this.apiBaseUrl.replace(/\/$/, '');
      return `${base}/${encodeURIComponent(this.currencyCode)}`;
    }

    normalize(data) {
      const troyOuncePrice = Number(data.price);
      const perGram = troyOuncePrice / 31.1034768 * (this.karat / 24);

      return {
        price: perGram,
        currencyCode: data.currency || this.currencyCode,
        updatedAt: data.updatedAt || new Date().toISOString()
      };
    }

    render(data) {
      if (!Number.isFinite(data.price)) {
        this.renderError();
        return;
      }

      this.valueElement.textContent = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: data.currencyCode,
        maximumFractionDigits: 2
      }).format(data.price);

      if (this.updatedElement && data.updatedAt) {
        const date = new Date(data.updatedAt);
        this.updatedElement.textContent = `${this.updatedPrefix}: ${new Intl.DateTimeFormat(undefined, {
          dateStyle: 'medium',
          timeStyle: 'short'
        }).format(date)}`;
      }
    }

    renderError() {
      this.valueElement.textContent = this.errorText;
      this.valueElement.classList.add('gold-price__value--error');
    }
  }

  document.querySelectorAll('[data-gold-price-section]:not([data-gold-price-loaded])').forEach((section) => {
    section.dataset.goldPriceLoaded = 'true';
    new GoldPriceSection(section).init();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-gold-price-section]');

    if (section) {
      section.dataset.goldPriceLoaded = 'true';
      new GoldPriceSection(section).init();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
